module.exports = __webpack_public_path__ + "img/21f31eabeb5dcce12c98dbe83b568ba1.png";